// extracted by mini-css-extract-plugin
export default {"msg":"BibliothequePlotly_msg__6dqLj","graphMain":"BibliothequePlotly_graphMain__OpVea"};